import { useMemo } from "react"

import { useScreenSize } from "shared/lib/useScreenSize"
import { TableCell } from "shared/ui/table/types"

export enum ProductPositionAddonRowCellType {
  POSITION = "position",
  CLARIFICATION_REQUEST = "clarification-request",
  NAME = "name",
  VARIANT_KEY = "variant-key"
}

export function useProductPositionAddonRowCells({
  showClarificationRequestColumn
}: {
  showClarificationRequestColumn?: boolean
} = {}) {
  const { isTablet } = useScreenSize()

  const cells = useMemo(() => {
    const crOffset = showClarificationRequestColumn ? 1 : 0
    const positionCell: TableCell = {
      key: ProductPositionAddonRowCellType.POSITION,
      colIndex: 1
    }
    const crCell: TableCell = {
      key: ProductPositionAddonRowCellType.CLARIFICATION_REQUEST,
      colIndex: 2
    }
    const nameCell: TableCell = {
      key: ProductPositionAddonRowCellType.NAME,
      colIndex: 2 + crOffset,
      colSpan: isTablet ? 6 : 1
    }
    const variantKeyCell: TableCell = {
      key: ProductPositionAddonRowCellType.VARIANT_KEY,
      colIndex: 3 + crOffset,
      colSpan: 6
    }
    if (isTablet) {
      return showClarificationRequestColumn
        ? [positionCell, crCell, nameCell]
        : [positionCell, nameCell]
    }

    return showClarificationRequestColumn
      ? [positionCell, crCell, nameCell, variantKeyCell]
      : [positionCell, nameCell, variantKeyCell]
  }, [isTablet, showClarificationRequestColumn])

  return { cells }
}
